import { ThemeProvider } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { LicenseEntriesForm } from '../components/licenseEntriesForm';
import Loader from 'components/v2/common/loader';
import PageHeader from 'components/v2/common/pageHeader';
import PageBackground from 'components/v2/PageBackground';

import { normalizeLicenses } from 'helpers/license';
import { useLicenses } from 'hooks/useLicenses';
import useTranslate from 'hooks/useTranslate';
import { setAlert } from 'redux/alert';
import appThemeV2 from 'theme/themeV2';
import { getErrorMessage } from 'utils/v2/errorHelper';

const LicenseDetails: React.FC = () => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();
    const { data, error, isError, isFetching, isPending } = useLicenses();

    useEffect(() => {
        if (!isError || isFetching) return;

        dispatch(
            setAlert({
                message: getErrorMessage(error, translate('somethingWentWrong')),
                type: 'error',
            })
        );
    }, [dispatch, error, isError, isFetching, translate]);

    const licenses = useMemo(() => data ?? normalizeLicenses(null), [data]);

    return (
        <ThemeProvider theme={appThemeV2}>
            <PageBackground maxWidth="md" sx={{ ml: 'inherit' }}>
                <PageHeader title="licenseDetails" description="licenseDetailsDescription" />
                {isPending ? (
                    <Loader message={translate('loading')} />
                ) : (
                    <LicenseEntriesForm initialLicenses={licenses} />
                )}
            </PageBackground>
        </ThemeProvider>
    );
};

export default LicenseDetails;
